import { useState, useContext } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { FiLock, FiUser, FiEye, FiEyeOff } from 'react-icons/fi';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import programSwitchService from '../../services/programSwitchService';
import GlobalContext from '../../contexts/GlobalContext';

const ModalTrocaPrograma = ({ show, onHide, targetProgram, onSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const { setGlobalValue } = useContext(GlobalContext);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await programSwitchService.performProgramSwitch(
                username,
                password,
                targetProgram,
                setGlobalValue
            );
            
            onSuccess();
            
        } catch (err) {
            let msg = 'Erro ao realizar o login, tente novamente.';
            if (err.response && err.response.data) {
                const data = err.response.data;
                if (data.non_field_errors) {
                    msg = data.non_field_errors.join(' ');
                } else if (data.response) {
                    msg = data.response;
                } else {
                    msg = JSON.stringify(data);
                }
            }
            
            withReactContent(Swal).fire({
                icon: 'warning',
                title: 'Atenção!',
                html: `<p>Não foi possível realizar o login.</p><p class="mt-4">${msg}</p>`
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal 
            show={show} 
            onHide={onHide} 
            centered
            backdrop="static"
        >
            <Modal.Header closeButton style={{
                borderBottom: '1px solid #e9ecef',
                padding: '1.5rem'
            }}>
                <Modal.Title style={{
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    color: '#212529',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.75rem'
                }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        borderRadius: '10px',
                        background: 'linear-gradient(135deg, #bccd02 0%, #a8b902 100%)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: 'white',
                        fontSize: '1.25rem'
                    }}>
                        <FiLock />
                    </div>
                    Acessar {targetProgram?.nome}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ padding: '2rem' }}>
                <p style={{
                    color: '#6c757d',
                    marginBottom: '1.5rem',
                    fontSize: '0.95rem',
                    lineHeight: '1.6'
                }}>
                    Para acessar este programa, confirme suas credenciais de acesso.
                </p>
                
                
                <Form onSubmit={handleLogin}>
                    <Form.Group className="mb-4" controlId="formBasicEmail">
                        <Form.Label style={{
                            fontWeight: '500',
                            color: '#495057',
                            marginBottom: '0.5rem',
                            fontSize: '0.9rem'
                        }}>
                            Login
                        </Form.Label>
                        <div style={{ position: 'relative' }}>
                            <FiUser style={{
                                position: 'absolute',
                                left: '14px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#adb5bd',
                                fontSize: '1.1rem',
                                zIndex: 1
                            }} />
                            <Form.Control 
                                type="text" 
                                placeholder="Digite seu login" 
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                required
                                style={{
                                    paddingLeft: '42px',
                                    height: '48px',
                                    borderRadius: '8px',
                                    border: '1.5px solid #dee2e6',
                                    fontSize: '0.95rem',
                                    transition: 'all 0.2s ease'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#bccd02';
                                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(188, 205, 2, 0.15)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#dee2e6';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                        </div>
                    </Form.Group>

                    <Form.Group className="mb-4" controlId="formBasicPassword">
                        <Form.Label style={{
                            fontWeight: '500',
                            color: '#495057',
                            marginBottom: '0.5rem',
                            fontSize: '0.9rem'
                        }}>
                            Senha
                        </Form.Label>
                        <div style={{ position: 'relative' }}>
                            <FiLock style={{
                                position: 'absolute',
                                left: '14px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                color: '#adb5bd',
                                fontSize: '1.1rem',
                                zIndex: 1
                            }} />
                            <Form.Control 
                                type={showPassword ? "text" : "password"}
                                placeholder="Digite sua senha" 
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                style={{
                                    paddingLeft: '42px',
                                    paddingRight: '42px',
                                    height: '48px',
                                    borderRadius: '8px',
                                    border: '1.5px solid #dee2e6',
                                    fontSize: '0.95rem',
                                    transition: 'all 0.2s ease'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = '#bccd02';
                                    e.target.style.boxShadow = '0 0 0 0.2rem rgba(188, 205, 2, 0.15)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = '#dee2e6';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPassword(!showPassword)}
                                style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'none',
                                    border: 'none',
                                    color: '#adb5bd',
                                    cursor: 'pointer',
                                    padding: '4px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    fontSize: '1.1rem',
                                    transition: 'color 0.2s ease',
                                    zIndex: 1
                                }}
                                onMouseEnter={(e) => e.target.style.color = '#bccd02'}
                                onMouseLeave={(e) => e.target.style.color = '#adb5bd'}
                            >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                            </button>
                        </div>
                    </Form.Group>
                    
                    <div className="d-flex justify-content-end gap-2" style={{ marginTop: '2rem' }}>
                        <Button 
                            variant="outline-danger" 
                            onClick={onHide}
                            disabled={loading}
                            style={{
                                height: '44px',
                                paddingLeft: '1.5rem',
                                paddingRight: '1.5rem',
                                borderRadius: '8px',
                                fontWeight: '500',
                                fontSize: '0.95rem',
                                transition: 'all 0.2s ease'
                            }}
                        >
                            Cancelar
                        </Button>
                        <Button 
                            variant="primary" 
                            type="submit" 
                            disabled={loading}
                            style={{
                                height: '44px',
                                paddingLeft: '2rem',
                                paddingRight: '2rem',
                                borderRadius: '8px',
                                fontWeight: '500',
                                fontSize: '0.95rem',
                                background: loading ? '#bccd02' : 'linear-gradient(135deg, #bccd02 0%, #a8b902 100%)',
                                border: 'none',
                                transition: 'all 0.2s ease',
                                minWidth: '120px'
                            }}
                        >
                            {loading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Acessando...
                                </>
                            ) : (
                                'Acessar'
                            )}
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ModalTrocaPrograma;
